import { notificationApis } from '@apis/notificationApis';
import { useQuery } from '@hooks/useQuery';
import { NotificationSearchQuery } from '@models/Notification';

export const useNotification = (query: NotificationSearchQuery) => {
  return useQuery([`/notification/`, query], () =>
    notificationApis
      .get('/notification/', {
        query: {
          ...query,
          page: (query.page ?? 0) + 1,
        },
      })
      .then((r) => r[200]!),
  );
};
